export const CUSTOM_UNLOCK_CONTROL_ID = 'custom-unlock-control';
export const CUSTOM_UNLOCK_CONTROL_MARGIN = 30;
